<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <h4 class="text-uppercase mb-3">{{ $t('Events') }}</h4>
        <label>{{ $t('PushNotifications') }}</label>
        <vs-switch v-model="eventoNoti" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
        <label>{{ $t('ByEmail') }}</label>
        <vs-switch v-model="eventoEmail" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
        <label>{{ $t('BySMS') }}</label>
        <vs-switch v-model="eventoSms" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <h4 class="text-uppercase mb-3">{{ $t('Incidences') }}</h4>
        <label>{{ $t('PushNotifications') }}</label>
        <vs-switch v-model="incidenciaNoti" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
        <label>{{ $t('ByEmail') }}</label>
        <vs-switch v-model="incidenciaEmail" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
        <label>{{ $t('BySMS') }}</label>
        <vs-switch v-model="incidenciaSms" icon-pack="feather" vs-icon-off="icon-x" vs-icon-on="icon-bell" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      eventoNoti: false,
      eventoEmail: false,
      eventoSms: false,
      incidenciaNoti: true,
      incidenciaEmail: false,
      incidenciaSms: true,
    };
  },
};
</script>
